import { Route } from '../models'

import React from 'react'

import HomeLayout from 'layouts/HomeLayout'

const Home = React.lazy(() => import('../pages/Home'))
const Error = React.lazy(() => import('../pages/Error'))

export const routes: Route[] = [
  {
    path: '/',
    page: Home,
    layout: HomeLayout,
  },
  {
    path: '*',
    page: Error,
    layout: HomeLayout,
  },
]
